// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { ITemplateFactory, ITemplate } from '../../../../CommonScripts/Abstractions';
import Vue from 'Vue';
import {removeInvalidJavascriptChars} from './Utils';
/**
* Create vue components from html and json
* @public
*/
export class TemplateFactory implements ITemplateFactory {
    /**
     * @inheritdoc 
     */
    createComponent(name: string, html: string, json: string, props:string[]): ITemplate {
        let compiledTemplate = null;
        let vueComponent: ITemplate = null;
        try {
            compiledTemplate = Vue.compile(html);
        }
        catch (err) {
            console.error(`failed to compile template ${name}`);
            console.error(`error : ${err.toString()}`);
        }
        if (compiledTemplate !== null) {
            let logic = null;
            if (json)
                try {
                    logic = JSON.parse(json,
                        (key, value) => {
                            let retVal = null;
                            if (value &&
                                typeof value === 'string' &&
                                value.substr(0, 8) === 'function') {
                                const startBody = value.indexOf('{') + 1;
                                const endBody = value.lastIndexOf('}');
                                const startArgs = value.indexOf('(') + 1;
                                const endArgs = value.indexOf(')');

                                retVal = new Function(value.substring(startArgs, endArgs),
                                    value.substring(startBody, endBody));
                            } else
                                retVal = value;

                            return retVal;
                        });
                    if (!logic) {
                        logic = {};
                    }
                    logic.render = compiledTemplate.render;
                    logic.staticRenderFns = compiledTemplate.staticRenderFns;
                    logic.name = `t_${removeInvalidJavascriptChars(name)}`;
                    logic.props = props;
                    vueComponent = { name: name, component: Vue.extend(logic) };

                }
                catch (logicErr) {
                    console.error(`failed to parse logic for template ${name}`);
                    console.error(`error : ${logicErr.toString()}`);
                }
        }
        return vueComponent;
    }
}

